import * as LabelPrimitive from '@radix-ui/react-label';
import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

// Kept byte-equal to FIELD_LABEL in `src/lib/ui-tokens.ts` (size, weight and
// contrast), guarded by `__tests__/label.default-matches-field-label.test.tsx`.
// `text-caption` (12px desktop / 13px mobile), not `text-sm`: at 14px/500 the
// label was the same size as the value inside the control it names AND a
// heavier weight, so the caption out-weighed its own content.
const labelVariants = cva(
  'text-caption font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-foreground/70',
  {
    variants: {
      spacing: {
        default: 'mb-2 block',
        none: '',
      },
    },
    defaultVariants: {
      spacing: 'default',
    },
  },
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, spacing, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ spacing }), className)} {...props} />
));
Label.displayName = 'Label';

export { Label };
